<template>
    <div class="ckeditor">
        <textarea :id="id" :value="value"></textarea>
    </div>
</template>
<script>
    export default {
        name: 'Ckeditor',
        props: {
            value: {
                type: String
            },
            id: {
                type: String,
                default: 'editor'
            },
            height: {
                type: String,
                default: '200px'
            },
            toolbar: {
                type: Array,
                default: () => [
                    ['Format','Undo', 'Redo', 'justifycenter', 'Table',' filebrowser'],
                    ['Bold', 'Italic', 'Strike','Image','Browser'],
                    ['NumberedList', 'BulletedList'],
                    ['align', 'indent', 'Paste', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock','Source','CodeSnippet']
                ]
            },
            language: {
                type: String,
                default: 'pt-BR'
            },
            extraplugins: {
                type: String,
                default: 'codesnippet'
            }
        },
        beforeUpdate () {
            const ckeditorId = this.id
            if (this.value !== CKEDITOR.instances[ckeditorId].getData()) {
                CKEDITOR.instances[ckeditorId].setData(this.value)
            }
        },
        mounted () {
            const ckeditorId = this.id
            const ckeditorConfig = {
                language: this.language,
                height: this.height,
                Credentials: true
            }
            CKEDITOR.replace(ckeditorId, ckeditorConfig)
            CKEDITOR.instances[ckeditorId].setData(this.value)
            CKEDITOR.instances[ckeditorId].on('change', () => {
                let ckeditorData = CKEDITOR.instances[ckeditorId].getData()
                if (ckeditorData !== this.value) {
                    this.$emit('input', ckeditorData)
                }
            })
        },
        destroyed () {
            const ckeditorId = this.id
            if (CKEDITOR.instances[ckeditorId]) {
                CKEDITOR.instances[ckeditorId].destroy()
            }
        }
    }
</script>
